import { BrandId } from './brand';
import { Environment } from './environment';
import { EnvironmentType } from './environment-type.enum';

export const environments: Environment[] = [
  {
    url: 'portal.groundfloordelivery.com',
    title: 'Groundfloor Portal',
    type: EnvironmentType.Production,
    brandId: BrandId.Groundfloor,
    clientId: 'client_01J6ZM951XDZ3KYFRHN3ZYDQR9',
    workosApiHostname: 'auth-api.groundfloordelivery.com',
    mgmtUrl: 'https://apis.groundfloordelivery.com/mgmt',
    signalREndpoint: 'https://mgmt-service-signalr-prd.groundfloordelivery.com/api/',
    acUrl: 'https://admin.groundfloordelivery.com/',
    registrationPagesUrl: 'https://registration.groundfloordelivery.com/occupants/',
    appInsightsConnectionString:
      'InstrumentationKey=dd35aa2c-7e6b-4c9c-b429-168d55b1f06e;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/'
  },
  {
    url: 'portal-test.groundfloordelivery.com',
    title: 'Groundfloor Portal - Test',
    type: EnvironmentType.Test,
    brandId: BrandId.Groundfloor,
    clientId: 'client_01J6ZM94PT8PP2N7C2XH3ZDQCG',
    mgmtUrl: 'https://apis-test.groundfloordelivery.com/mgmt',
    signalREndpoint: 'https://mgmt-service-signalr-tst.groundfloordelivery.com/api/',
    acUrl: 'https://test.groundfloordelivery.com/',
    registrationPagesUrl: 'https://embedded-pages-test.groundfloordelivery.com/occupants/',
    appInsightsConnectionString:
      'InstrumentationKey=d002dc16-3143-475a-8c6f-62d82ddc0b15;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/'
  },
  {
    url: 'portal.lastk.io',
    title: 'LastK Portal',
    type: EnvironmentType.Production,
    brandId: BrandId.LastK,
    clientId: 'client_01JHRHGCW776MK3ANQ02Z9JQ7W',
    workosApiHostname: 'auth-api.lastk.io',
    mgmtUrl: 'https://api.lastk.io/mgmt',
    signalREndpoint: 'https://events.lastk.io/api/',
    acUrl: 'https://admin.groundfloordelivery.com/',
    registrationPagesUrl: 'https://registration.groundfloordelivery.com/occupants/',
    appInsightsConnectionString:
      'InstrumentationKey=dd35aa2c-7e6b-4c9c-b429-168d55b1f06e;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/'
  },
  {
    url: 'portal-test.lastk.io',
    title: 'LastK Portal - Test',
    type: EnvironmentType.Test,
    brandId: BrandId.LastK,
    clientId: 'client_01JHRHGCNMEDBQY7YHFQ3JCMK3',
    mgmtUrl: 'https://api-test.lastk.io/mgmt/',
    signalREndpoint: 'https://events-test.lastk.io/api/',
    acUrl: 'https://test.groundfloordelivery.com/',
    registrationPagesUrl: 'https://embedded-pages-test.groundfloordelivery.com/occupants/',
    appInsightsConnectionString:
      'InstrumentationKey=d002dc16-3143-475a-8c6f-62d82ddc0b15;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/'
  },
  {
    url: 'localhost',
    title: 'LastK Portal - Test',
    type: EnvironmentType.Test,
    brandId: BrandId.LastK,
    clientId: 'client_01JHRHGCNMEDBQY7YHFQ3JCMK3',
    mgmtUrl: 'https://api-test.lastk.io/mgmt/',
    signalREndpoint: 'https://events-test.lastk.io/api/',
    acUrl: 'https://test.groundfloordelivery.com/',
    registrationPagesUrl: 'https://embedded-pages-test.groundfloordelivery.com/occupants/',
    appInsightsConnectionString:
      'InstrumentationKey=d002dc16-3143-475a-8c6f-62d82ddc0b15;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/'
  }
];
